define(['jquery', './brain-common', 'cookieconsent'], function($, modCommon) {
    "use strict";
    return {

        init: function() {
            var $dataElt = $('#cc-data');
            var position = $dataElt.data('position');
            if (!position) {
                position = 'bottom';
            }
            var cookieconsentOptions = {
                "content":{
                    "message": $dataElt.data('message'),
                    "dismiss": $dataElt.data('dismiss'),
                    "link": $dataElt.data('link'),
                    "href": $dataElt.data('href'),
                    "target": '_self'
                },
                "position": $dataElt.data('position'),
                "static": $dataElt.data('static')
            };
            //window.cookieconsent.initialise(cookieconsentOptions);
            cookieconsentOptions.autoAttach = false;
            if (position === 'top') {
                var spacerSelector = $dataElt.data('spacer-selector') ? $dataElt.data('spacer-selector') : 'body';
                var durationOn = $dataElt.data('duration-on');
                var durationOff = $dataElt.data('duration-off');
                cookieconsentOptions.onPopupOpen = function() {
                    setTimeout(function(){
                        var $ccWindow = $('.cc-window');
                        var paddingTop = $ccWindow.outerHeight();
                        $ccWindow.css('top', - paddingTop);
                        $ccWindow.animate({ 'top' : 0+'px' }, durationOn);
                        if (!paddingTop) {
                            paddingTop = 74;
                        }
                        //$('body').animate({ 'padding-top' : paddingTop+'px' }, durationOn);
                        jQuery(spacerSelector).animate({ 'padding-top' : paddingTop+'px' }, durationOn, function(){
                            // fallback initial cc-window height has changed
                            jQuery(spacerSelector).css({ 'padding-top' : $ccWindow.outerHeight() + 'px' });
                        });
                    }, 30);
                };
                cookieconsentOptions.onPopupClose = function() {
                    jQuery(spacerSelector).animate({ 'padding-top' : '0px' }, durationOff);
                    var event = $.Event('ba.cc.closed');
                    $('.cc-listener').trigger(event);
                };

                var ccResize = modCommon.debounce(function() {
                    var $ccWindow = $('.cc-window');
                    if ($ccWindow.length > 0 && $ccWindow.is(':visible')) {
                        var paddingTop = $ccWindow.outerHeight();
                        jQuery(spacerSelector).css({ 'padding-top' : paddingTop + 'px' });
                    }
                }, 100);
                $(window).resize(ccResize);
            }
            cookieconsentOptions.window = '<div role="dialog" aria-live="polite" aria-label="cookieconsent" aria-describedby="cookieconsent:desc" class="cc-window {{classes}}"><!--googleoff: all--><div class="container">{{children}}<!--googleon: all--></div></div>';
            var instance = new window.cookieconsent.Popup(cookieconsentOptions);
            document.body.appendChild(instance.element);
        }
    };
});